export const environment = {
  production: false,
  apiUrl: 'https://eclesys-cerimonial-api.dev.ezycode.com.br/api/v1',
  wsUrl: 'wss://cerimonial-ws.dev.ezycode.com.br',
  googleClientId: '173779937948-nskqahp9fhflfq63bvhujjbbif1fqcbb.apps.googleusercontent.com'
};
